'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm from "./app.data.-App-Document-Data-Form.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$CreditNote$() {
}
export { $c_Lapp_data_AppDocumentDataForm$CreditNote$ as $c_Lapp_data_AppDocumentDataForm$CreditNote$ };
$p = $c_Lapp_data_AppDocumentDataForm$CreditNote$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$CreditNote$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$CreditNote$() {
}
export { $h_Lapp_data_AppDocumentDataForm$CreditNote$ as $h_Lapp_data_AppDocumentDataForm$CreditNote$ };
$h_Lapp_data_AppDocumentDataForm$CreditNote$.prototype = $p;
$p.n = (function() {
  return "CreditNote";
});
$p.bKj = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$CreditNote(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKj(p);
});
var $d_Lapp_data_AppDocumentDataForm$CreditNote$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$CreditNote$, "app.data.AppDocumentDataForm$CreditNote$", ({
  B6: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$CreditNote$ as $d_Lapp_data_AppDocumentDataForm$CreditNote$ };
var $n_Lapp_data_AppDocumentDataForm$CreditNote$;
function $m_Lapp_data_AppDocumentDataForm$CreditNote$() {
  if ((!$n_Lapp_data_AppDocumentDataForm$CreditNote$)) {
    $n_Lapp_data_AppDocumentDataForm$CreditNote$ = new $c_Lapp_data_AppDocumentDataForm$CreditNote$();
  }
  return $n_Lapp_data_AppDocumentDataForm$CreditNote$;
}
export { $m_Lapp_data_AppDocumentDataForm$CreditNote$ as $m_Lapp_data_AppDocumentDataForm$CreditNote$ };
//# sourceMappingURL=app.data.-App-Document-Data-Form$-Credit-Note$.js.map
